export default class LegDashGrantsModal {
  constructor(modalContainer) {
    this.modalContainer = modalContainer;
    this.modal = this.modalContainer.querySelector('.js-grant-modal');
    this.showModalBtn = this.modalContainer.querySelector(
      '.js-show-grant-modal'
    );
    this.closeModalBtn = this.modalContainer.querySelector(
      '.js-close-grant-modal'
    );

    if (this.showModalBtn && this.modal && this.closeModal) {
      this.events();
    }
  }

  events() {
    //Open Modal
    this.showModalBtn.addEventListener('click', () =>
      this.showModal(this.modal)
    );

    //Close Modal
    this.closeModalBtn.addEventListener('click', () =>
      this.closeModal(this.modal)
    );

    this.modal.addEventListener('click', (e) => this.clickOffModal(e));
  }

  clickOffModal(e) {
    if (e.target.classList.contains('--show-modal')) {
      this.closeModal(this.modal);
    }
  }

  showModal(modal) {
    //const scrollPosition = window.scrollY;
    //console.log(scrollPosition);
    modal.classList.add('--show-modal');

    //document.body.style.position = 'fixed';
    //document.body.style.top = -scrollPosition + 'px';
  }

  closeModal(modal) {
    //const scrollPosition = window.scrollY;
    modal.classList.remove('--show-modal');

    //document.body.style.position = 'relative';
    //document.body.style.top = -scrollPosition + 'px';
  }
}
